import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import bg3 from "../../assect/images/bg/03.jpg";
import logo from "../../assect/images/logomobile.gif";
import { Oval } from 'react-loader-spinner';
import authService from "../../services/authService";

export default function Signup() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
        user_type: "perusahaan",
        company_name: "",
        company_address: "",
        company_phone: "",
        npwp: "",
        company_email: ""
    });
    const [currentStep, setCurrentStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const nextStep = () => {
        setCurrentStep(prev => Math.min(prev + 1, 3));
        setError(null);
    };

    const prevStep = () => {
        setCurrentStep(prev => Math.max(prev - 1, 1));
        setError(null);
    };

    const validateStep = (step) => {
        switch (step) {
            case 1:
                return formData.name && formData.email && formData.password && formData.password_confirmation;
            case 2:
                return formData.user_type === 'personal' || 
                       (formData.company_name && formData.company_address && formData.company_phone && formData.npwp && formData.company_email);
            case 3:
                return true;
            default:
                return false;
        }
    };

    const renderStepIndicator = () => {
        if (formData.user_type !== 'perusahaan') return null;

        const steps = [
            { number: 1, title: "Data Personal" },
            { number: 2, title: "Data Perusahaan" },
            { number: 3, title: "Konfirmasi" }
        ];

        return (
            <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center">
                    {steps.map((step, index) => (
                        <div key={step.number} className="d-flex align-items-center">
                            <div className={`rounded-circle d-flex align-items-center justify-content-center ${
                                currentStep >= step.number ? 'bg-primary text-white' : 'bg-light text-muted'
                            }`} style={{width: '40px', height: '40px', fontSize: '14px', fontWeight: 'bold'}}>
                                {currentStep > step.number ? '✓' : step.number}
                            </div>
                            <span className={`ms-2 small ${currentStep >= step.number ? 'text-primary' : 'text-muted'}`}>
                                {step.title}
                            </span>
                            {index < steps.length - 1 && (
                                <div className={`mx-3 ${currentStep > step.number ? 'text-primary' : 'text-muted'}`} 
                                     style={{width: '30px', textAlign: 'center'}}>
                                    →
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                <hr className="mt-3 mb-4" />
            </div>
        );
    };

    const renderStepContent = () => {
        if (formData.user_type !== 'perusahaan') {
            // Render form biasa untuk personal
            return (
                <>
                    <div className="form-floating mb-3">
                        <input 
                            type="text" 
                            className="form-control" 
                            id="name" 
                            name="name"
                            value={formData.name} 
                            onChange={handleChange} 
                            placeholder="Nama Anda"
                            required
                        />
                        <label htmlFor="name">Nama Lengkap</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input 
                            type="email" 
                            className="form-control" 
                            id="email" 
                            name="email"
                            value={formData.email} 
                            onChange={handleChange} 
                            placeholder="name@example.com"
                            required
                        />
                        <label htmlFor="email">Alamat Email</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input 
                            type="password" 
                            className="form-control" 
                            id="password" 
                            name="password"
                            value={formData.password} 
                            onChange={handleChange} 
                            placeholder="Kata Sandi"
                            required
                            minLength={8}
                        />
                        <label htmlFor="password">Kata Sandi</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input 
                            type="password" 
                            className="form-control" 
                            id="password_confirmation" 
                            name="password_confirmation"
                            value={formData.password_confirmation} 
                            onChange={handleChange} 
                            placeholder="Konfirmasi Kata Sandi"
                            required
                        />
                        <label htmlFor="password_confirmation">Konfirmasi Kata Sandi</label>
                    </div>
                </>
            );
        }

        // Render wizard steps untuk perusahaan
        switch (currentStep) {
            case 1:
                return (
                    <>
                        <h6 className="mb-3 text-primary">Step 1: Data Personal</h6>
                        <div className="form-floating mb-3">
                            <input 
                                type="text" 
                                className="form-control" 
                                id="name" 
                                name="name"
                                value={formData.name} 
                                onChange={handleChange} 
                                placeholder="Nama Anda"
                                required
                            />
                            <label htmlFor="name">Nama Lengkap</label>
                        </div>

                        <div className="form-floating mb-3">
                            <input 
                                type="email" 
                                className="form-control" 
                                id="email" 
                                name="email"
                                value={formData.email} 
                                onChange={handleChange} 
                                placeholder="name@example.com"
                                required
                            />
                            <label htmlFor="email">Alamat Email Personal</label>
                        </div>

                        <div className="form-floating mb-3">
                            <input 
                                type="password" 
                                className="form-control" 
                                id="password" 
                                name="password"
                                value={formData.password} 
                                onChange={handleChange} 
                                placeholder="Kata Sandi"
                                required
                                minLength={8}
                            />
                            <label htmlFor="password">Kata Sandi</label>
                        </div>

                        <div className="form-floating mb-3">
                            <input 
                                type="password" 
                                className="form-control" 
                                id="password_confirmation" 
                                name="password_confirmation"
                                value={formData.password_confirmation} 
                                onChange={handleChange} 
                                placeholder="Konfirmasi Kata Sandi"
                                required
                            />
                            <label htmlFor="password_confirmation">Konfirmasi Kata Sandi</label>
                        </div>
                    </>
                );
            case 2:
                return (
                    <>
                        <h6 className="mb-3 text-primary">Step 2: Data Perusahaan</h6>
                        <div className="form-floating mb-3">
                            <input 
                                type="text" 
                                className="form-control" 
                                id="company_name" 
                                name="company_name"
                                value={formData.company_name} 
                                onChange={handleChange} 
                                placeholder="Nama Perusahaan"
                                required
                            />
                            <label htmlFor="company_name">Nama Perusahaan</label>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="company_address" className="form-label">Alamat Perusahaan</label>
                            <textarea 
                                className="form-control" 
                                id="company_address" 
                                name="company_address"
                                value={formData.company_address} 
                                onChange={handleChange} 
                                placeholder="Alamat Perusahaan"
                                required
                                rows="2"
                                style={{resize: 'vertical', minHeight: '60px'}}
                            />
                        </div>

                        <div className="form-floating mb-3">
                            <input 
                                type="tel" 
                                className="form-control" 
                                id="company_phone" 
                                name="company_phone"
                                value={formData.company_phone} 
                                onChange={handleChange} 
                                placeholder="Telepon Perusahaan"
                                required
                            />
                            <label htmlFor="company_phone">Telepon Perusahaan</label>
                        </div>

                        <div className="form-floating mb-3">
                            <input 
                                type="text" 
                                className="form-control" 
                                id="npwp" 
                                name="npwp"
                                value={formData.npwp} 
                                onChange={handleChange} 
                                placeholder="NPWP"
                                required
                            />
                            <label htmlFor="npwp">NPWP</label>
                        </div>

                        <div className="form-floating mb-3">
                            <input 
                                type="email" 
                                className="form-control" 
                                id="company_email" 
                                name="company_email"
                                value={formData.company_email} 
                                onChange={handleChange} 
                                placeholder="Email Perusahaan"
                                required
                            />
                            <label htmlFor="company_email">Email Perusahaan</label>
                        </div>
                    </>
                );
            case 3:
                return (
                    <>
                        <h6 className="mb-3 text-primary">Step 3: Konfirmasi Data</h6>
                        <div className="card">
                            <div className="card-body">
                                <h6 className="card-subtitle mb-2 text-muted">Data Personal</h6>
                                <p className="mb-1"><strong>Nama:</strong> {formData.name}</p>
                                <p className="mb-3"><strong>Email:</strong> {formData.email}</p>
                                
                                <h6 className="card-subtitle mb-2 text-muted">Data Perusahaan</h6>
                                <p className="mb-1"><strong>Nama Perusahaan:</strong> {formData.company_name}</p>
                                <p className="mb-1"><strong>Alamat:</strong> {formData.company_address}</p>
                                <p className="mb-1"><strong>Telepon:</strong> {formData.company_phone}</p>
                                <p className="mb-1"><strong>NPWP:</strong> {formData.npwp}</p>
                                <p className="mb-1"><strong>Email Perusahaan:</strong> {formData.company_email}</p>
                            </div>
                        </div>
                        <div className="alert alert-info mt-3">
                            <small>Pastikan semua data sudah benar sebelum mendaftar.</small>
                        </div>
                    </>
                );
            default:
                return null;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        // Validate passwords match
        if (formData.password !== formData.password_confirmation) {
            setError("Kata sandi tidak cocok");
            setLoading(false);
            return;
        }

        try {
            await authService.register(formData);
            setSuccess(true);
            setError(null);
            
            // Redirect to login after brief delay
            setTimeout(() => {
                navigate('/auth-login');
            }, 2000);
        } catch (err) {
            setError(err.message || "Pendaftaran gagal. Silakan coba lagi.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <section className="bg-home zoom-image" style={{minHeight: '100vh', paddingTop: '2rem', paddingBottom: '2rem'}}>
            <div className="bg-overlay image-wrap" style={{background: "linear-gradient(to right, #3494E6, #EC6EAD)", boxShadow: "0 4px 15px rgba(0,0,0,0.1)", backgroundPosition: 'center'}}></div>
            <div className="bg-overlay bg-gradient-overlay"></div>
            <div className="container-fluid px-3">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
                        <div className="p-3 p-md-4 bg-white rounded-3 shadow-md w-100" style={{
                            maxHeight: 'calc(100vh - 4rem)', 
                            overflowY: 'auto',
                            marginTop: '1rem',
                            marginBottom: '1rem'
                        }}>
                            {loading ? (
                                <div className="text-center py-4">
                                    <Oval
                                        visible={true}
                                        height="80"
                                        width="80"
                                        color="#4fa94d"
                                        ariaLabel="oval-loading"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                    />
                                    <p className="mt-3">Membuat akun Anda...</p>
                                </div>
                            ) : success ? (
                                <div className="text-center py-4">
                                    <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success" style={{fontSize: '64px'}}></i>
                                    </div>
                                    <h5 className="mb-3">Pendaftaran Berhasil!</h5>
                                    <p>Mengarahkan Anda ke halaman masuk...</p>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit}>
                                    <Link to="/"><img src={logo} className="mb-4 d-block mx-auto" alt="" style={{height:70}}/></Link>
                                    <h5 className="mb-3">Daftar</h5>
                                    
                                    {error && (
                                        <div className="alert alert-danger" role="alert">
                                            {error}
                                        </div>
                                    )}

                                    {/* User Type Selection */}
                                    <div className="mb-3">
                                        <label className="form-label">Daftar sebagai</label>
                                        <div className="d-flex gap-3">
                                            <div className="form-check">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="user_type" 
                                                    id="personal" 
                                                    value="personal"
                                                    checked={formData.user_type === 'personal'}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        setCurrentStep(1);
                                                    }}
                                                    disabled={true}
                                                />
                                                <label className="form-check-label" htmlFor="personal" style={{opacity: 0.5, cursor: 'not-allowed'}}>
                                                    Personal
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input 
                                                    className="form-check-input" 
                                                    type="radio" 
                                                    name="user_type" 
                                                    id="perusahaan" 
                                                    value="perusahaan"
                                                    checked={formData.user_type === 'perusahaan'}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        setCurrentStep(1);
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor="perusahaan">
                                                    Perusahaan
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Step Indicator untuk Perusahaan */}
                                    {renderStepIndicator()}
                                
                                    {/* Form Content */}
                                    {renderStepContent()}

                                    {/* Navigation Buttons */}
                                    {formData.user_type === 'perusahaan' ? (
                                        <div className="d-flex justify-content-between mt-4">
                                            {currentStep > 1 && (
                                                <button 
                                                    type="button" 
                                                    className="btn btn-outline-secondary"
                                                    onClick={prevStep}
                                                >
                                                    ← Sebelumnya
                                                </button>
                                            )}
                                            {currentStep < 3 ? (
                                                <button 
                                                    type="button" 
                                                    className={`btn btn-primary ${currentStep === 1 ? 'ms-auto' : ''}`}
                                                    onClick={() => {
                                                        if (formData.password !== formData.password_confirmation && currentStep === 1) {
                                                            setError("Kata sandi tidak cocok");
                                                            return;
                                                        }
                                                        if (validateStep(currentStep)) {
                                                            nextStep();
                                                        } else {
                                                            setError("Mohon lengkapi semua field yang diperlukan");
                                                        }
                                                    }}
                                                    disabled={!validateStep(currentStep)}
                                                >
                                                    Selanjutnya →
                                                </button>
                                            ) : (
                                                <button 
                                                    type="submit" 
                                                    className="btn btn-primary"
                                                >
                                                    Daftar Sekarang
                                                </button>
                                            )}
                                        </div>
                                    ) : (
                                        <button className="btn btn-primary w-100" type="submit">Daftar</button>
                                    )}

                                    <div className="col-12 text-center mt-3">
                                        <span><span className="text-muted me-2">Sudah punya akun? </span> 
                                        <Link to="/auth-login" className="text-dark fw-medium">Masuk</Link></span>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}